import {
  SIZE_DROPDOWN_OPTION_CONTENT,
  SIZE_DROPDOWN_OPTION_FULL_WIDTH,
  SIZE_DROPDOWN_OPTION_ORIGINAL,
  SIZE_DROPDOWN_OPTION_SMALL
} from "./../../../_shared/data-hooks";
import { SizeContentIcon, SizeFullWidthIcon, SizeOriginalIcon, SizeSmallIcon } from "../../icons";
const sizeMap = {
  CONTENT: {
    text: "SizeContentButton_Tooltip",
    tooltip: "SizeContentButton_Tooltip",
    commandKey: "CONTENT",
    icon: SizeContentIcon,
    dataHook: SIZE_DROPDOWN_OPTION_CONTENT
  },
  SMALL: {
    text: "SizeSmallCenterButton_Tooltip",
    tooltip: "SizeSmallCenterButton_Tooltip",
    commandKey: "SMALL",
    icon: SizeSmallIcon,
    dataHook: SIZE_DROPDOWN_OPTION_SMALL
  },
  ORIGINAL: {
    text: "SizeOriginalButton_Tooltip",
    tooltip: "SizeOriginalButton_Tooltip",
    commandKey: "ORIGINAL",
    icon: SizeOriginalIcon,
    dataHook: SIZE_DROPDOWN_OPTION_ORIGINAL
  },
  FULL_WIDTH: {
    text: "SizeFullWidthButton_Tooltip",
    tooltip: "SizeFullWidthButton_Tooltip",
    commandKey: "FULL_WIDTH",
    icon: SizeFullWidthIcon,
    dataHook: SIZE_DROPDOWN_OPTION_FULL_WIDTH
  }
};
const defaultSize = [sizeMap.SMALL, sizeMap.CONTENT, sizeMap.FULL_WIDTH];
const sizeIconMap = {
  CONTENT: SizeContentIcon,
  SMALL: SizeSmallIcon,
  ORIGINAL: SizeOriginalIcon,
  FULL_WIDTH: SizeFullWidthIcon
};
export {
  defaultSize,
  sizeIconMap,
  sizeMap
};
//# sourceMappingURL=consts.js.map
